import type { NavItem } from '../models/LayoutTypes';

const NavList: React.FC<{items: NavItem[]; isCompact?: boolean}> = ({ items, isCompact = false }) => {
  return (
    <nav aria-label="Section navigation">
      <ul className="space-y-1">
        {items.map(({ icon, label, href, active }) => (
          <div key={label}>
            <div data-testid="nav-icon" className="flex justify-center">
              {icon && (
                <a 
                  href={href}
                  className="block p-1 rounded-xl hover:bg-slate-100"
                  aria-label={label}
                >
                  <span dangerouslySetInnerHTML={{ __html: icon }}></span>
                </a>
              )}
            </div>
            <li>
              <a
                href={href}
                className={[
                  'block rounded-xl px-3 text-sm',
                  isCompact ? 'py-2 text-sm' : 'py-2.5',
                  active
                    ? 'nav-highlight'
                    : 'text-slate-700 hover:bg-slate-100',
                ].join(' ')}
                aria-current={active ? 'page' : undefined}
              >
                {label}
              </a>
            </li>
          </div>
        ))}
      </ul>
    </nav>
  );
};
export default NavList;
